import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import type { PermissionScope, PermissionScopeResources } from "~types/permissionScope";

type CachedPermissionScope = {
  scope: PermissionScope;
  resources: PermissionScopeResources;
};

export const useUpdatePermissionScopeCache = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (sport: string | undefined, organizationId: string | undefined, updater: (updatedScope: CachedPermissionScope) => void) => {
      queryClient.setQueryData<CachedPermissionScope>(["permission-scope-current-user", sport, organizationId], (oldScope) => {
        if (!oldScope) {
          return undefined;
        }

        const updatedScope = JSON.parse(JSON.stringify(oldScope)) as CachedPermissionScope;

        updater(updatedScope);

        return updatedScope;
      });
    },
    [queryClient],
  );
};
